import { connect } from 'react-redux'
import { email, required, minLength, fullName } from 'util/validation'
import withFormFields from 'shared/ui/Form/withFormFields'

import {
  doSignupAccount,
  doCheckSubdomain,
  doRedirectToHomeIfAuthenticated,
} from '../actions'

import { selectFormFields } from '../selectors'

import SignupFormView from './view'

let timeoutId = null
const validateSubdomain = value => {
  if (!value) return 'Must provide a domain'
  return new Promise(resolve => {
    if (timeoutId) clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      // HACK (jscheel): This is all sorts of ghetto.
      app.store.dispatch(doCheckSubdomain(value)).then(({ message }) => {
        resolve(message)
      })
    }, 400)
  })
}

const accept = value =>
  !value && 'Must accept terms of service and privacy policy'

const validators = {
  firstLastNameInput: fullName,
  emailInput: email,
  passwordInput: minLength(6),
  companyInput: required,
  subdomainInput: validateSubdomain,
  termsCheckbox: accept,
}

const select = state => ({
  initialValues: selectFormFields(state),
  validators,
})

const perform = {
  onSave: doSignupAccount,
  checkSubdomain: doCheckSubdomain,
  redirectToHomeIfAuthenticated: doRedirectToHomeIfAuthenticated,
}

export default connect(select, perform)(withFormFields(SignupFormView))
